import { c as _c } from "react/compiler-runtime";
import { IcoCheck24 } from '@onefootprint/icons';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import Flag from '../../../flag';
import type { ItemProps } from '../../../internal/base-select/components/picker/components/item';
import Text from '../../../text';
type MobileOptionProps = ItemProps;
const MobileOption = t0 => {
  const $ = _c(21);
  const {
    option,
    onSelect,
    value
  } = t0;
  const {
    label
  } = option;
  const selected = value?.value === option.value;
  let t1;
  if ($[0] !== onSelect) {
    t1 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelect();
      }
    };
    $[0] = onSelect;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== option.value || $[3] !== value) {
    t2 = value && <Flag className="mr-2 min-w-5" code={option.value as Iso3166TwoDigitCountryCode} />;
    $[2] = option.value;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== label) {
    t3 = <Text variant="body-2" className="text-(--dropdown-color-primary)">{label}</Text>;
    $[5] = label;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex items-center">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== selected) {
    t5 = selected ? <IcoCheck24 /> : null;
    $[10] = selected;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <div>{t5}</div>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <div className="fp-dropdown-item flex flex-row justify-between py-3 px-4 cursor-pointer">{t4}{t6}</div>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onSelect || $[18] !== t1 || $[19] !== t7) {
    t8 = <div role="option" onClick={onSelect} onKeyDown={t1} tabIndex={0}>{t7}</div>;
    $[17] = onSelect;
    $[18] = t1;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export default MobileOption;